import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PersonIddProgressModel } from 'src/app/models/dashboard/person-idd-progress.model';
import { DashboardWidgetsDataService } from 'src/app/services/dashboard-widget-data.service';
import { getDurationString } from 'src/app/utils/duration-formatter.utils';

@Component({
    selector: 'app-my-qualification-status-widget',
    templateUrl: './my-qualification-status-widget.component.html',
    styleUrl: './my-qualification-status-widget.component.scss',
    standalone: false
})
export class MyQualificationStatusWidgetComponent {
  employeeChartData = [
    {
      label: this.translateService.instant('DASHBOARD.HOURS-MISSING'),
      value: 0,
      originalValue: 0,
    },
    {
      label: this.translateService.instant('DASHBOARD.HOURS-SPENT'),
      value: 0,
      originalValue: 0,
    },
  ];

  employeeQualification: { current: string; target: string; missing: string } =
  {
    current: '00:00h',
    target: '00:00h',
    missing: '00:00h',
  };

  constructor(
    private translateService: TranslateService,
    private router: Router,
    private dashboardWidgetsDataService: DashboardWidgetsDataService
  ) {
    this.customizeEmployeeChartText = this.customizeEmployeeChartText.bind(this);
    this.customizeEmployeeChartPoint = this.customizeEmployeeChartPoint.bind(this);
  }

  ngOnInit() {
    this.dashboardWidgetsDataService.getPersonProgress().subscribe(data => {
      if (data) {
        const missingTime =
        data.tenantIddTimeMinutesTarget -
          data.sumIddTimeMinutesReached < 0
          ? 0
          : data.tenantIddTimeMinutesTarget -
            data.sumIddTimeMinutesReached;

        this.employeeQualification.current = getDurationString(
          data.sumIddTimeMinutesReached
        );
        this.employeeQualification.target = getDurationString(
          data.tenantIddTimeMinutesTarget
        );
        this.employeeQualification.missing =
          getDurationString(missingTime);

        const currentPercentage =
          Math.round(
            (100 * data.sumIddTimeMinutesReached) /
              data.tenantIddTimeMinutesTarget
          ) || 0;

        this.employeeChartData[0].value =
          currentPercentage <= 100 ? 100 - currentPercentage : 0;
        this.employeeChartData[1].value = currentPercentage;

        this.employeeChartData[0].originalValue =
          data.tenantIddTimeMinutesTarget;
        this.employeeChartData[1].originalValue =
          data.sumIddTimeMinutesReached;

        this.employeeChartData = [...this.employeeChartData];
      }
    });
  }

  customizeEmployeeChartPoint(pointInfo: any) {
    if (
      pointInfo.argument === 'Hours Missing' ||
      pointInfo.argument === 'Fehlende Stunden'
    ) {
      return { color: '#f53d3dcc' };
    } else {
      return { color: '#66cc66cc' };
    }
  }

  onEmployeePointClick() {
    this.router.navigate(['profile'], {
      queryParams: { tab: 'trainings' },
    });
  }

  customizeEmployeeChartText(arg: any) {
    const currentPercentage =
      Math.round(
        (100 * this.employeeChartData[1].originalValue) /
          this.employeeChartData[0].originalValue
      ) || 0;

    if (
      arg.pointName === 'Hours Missing' ||
      arg.pointName === 'Fehlende Stunden'
    ) {
      return `${arg.pointName}: ${this.employeeQualification.missing} (${
        currentPercentage < 100 ? 100 - currentPercentage : 0
      }%)`;
    } else {
      return `${arg.pointName}: ${this.employeeQualification.current} (${
        currentPercentage > 100 ? 100 : currentPercentage
      }%)`;
    }
  }
}
